import React, { useState, useEffect } from "react";
import MapsLeaflet from "./maps_leaflet";
import { Row, Container } from "reactstrap";
import api from "services/api";

const Maps = () => {
  useEffect(() => {
    const interval = setInterval(() => {
      getLocation();
    }, 90000);

    return () => {
      clearInterval(interval);
    };
  });

  useEffect(() => {
    getLocation();
  }, []);

  const getLocation = () => {
    api.get("/maps/location").then((response) => {
      setDadosMapa(response.data);
    });
  };

  const [dadosMapa, setDadosMapa] = useState([]);
  const [showMap, setShowMap] = useState(false);

  return (
    <React.Fragment>
      {showMap && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div
            style={{
              width: '100%',
              height: '100%',
              backgroundColor: 'white',
              position: 'relative'
            }}
            onKeyDown={(e) => {
              if (e.key === 'Escape') {
                setShowMap(false);
              }
            }}
            tabIndex={0}
          >
            <button
              className="btn btn-danger"
              onClick={() => setShowMap(false)}
              style={{
                position: 'absolute',
                right: '40px',
                top: '20px',
                cursor: 'pointer',
                zIndex: 10000
              }}
              type="button"
            >
              Fechar
            </button>
            <div style={{ width: "100%", height: "100%" }}>
              <MapsLeaflet dados={dadosMapa}/>
            </div>
          </div>
        </div>
      )}

      <Container className="mb-7 mt-5" fluid>
        <div className="mb-3" style={{ height: "6vw" }}></div>

        <div className="mb-3 d-flex flex-column align-items-center justify-content-center" style={{ height: "60px", marginBottom: "20px" }}>
          <div className="d-flex align-items-center justify-content-center">
            <button
              className="btn btn-primary mb-3"
              onKeyDown={(e) => {
                if (e.key === 'Escape') {
                  setShowMap(false);
                }
              }}
              onClick={() => setShowMap(!showMap)}
            >
              Mostrar mapa
            </button>
          </div>
        </div>

        <div className="mb-3" style={{ height: "15vw" }}></div>
      </Container>
    </React.Fragment>
  );
};

export default Maps;
